<template>
  <Row>
    <Col span="24">
      <!-- <div
        style="
          display: flex;
          width: 100%;
          background: linear-gradient(to bottom, #ffffff, #dddddd);
          margin-bottom: 20px;
        "
      >
        <img
          style="background: #02a0e7"
          src="../../../static/img/Buy/icon-home.png"
          alt="暂无照片"
        />
        <Breadcrumb style="margin: 10px 0 0 30px" separator=">">
          <BreadcrumbItem to="/">首页</BreadcrumbItem>
          <BreadcrumbItem to="/home/News">新闻资讯</BreadcrumbItem>
          <BreadcrumbItem>行业新闻</BreadcrumbItem>
        </Breadcrumb>
      </div> -->
      <div class="res_div">
        <p class="res_div_p">{{ title }}</p>
        <div class="res_div_div"></div>
        <div style="text-align: center">
          <span class="news_ul_div_div02_sp">
            发布时间：2020-12-02
          </span>
        </div>
        <div v-for="(item, index) in img" :key="index">
          <p class="font_div">{{ item.p }}</p>
          <img v-if="item.imgUrl !== ''" :src="item.imgUrl" alt="暂无照片" />
        </div>
      </div>
    </Col>
  </Row>
</template>

<script>
export default {
  data() {
    return {
      title: "实测实量管理系统亮相中建系统第三届技术论坛",
      img: [
        {
          imgUrl: "../../../static/img/News/NewsOne/newsOne01.jpg",
          p: "11月23日-24日,2020年中建科技月中建五局分会场暨中建五局第三届技术论坛在重庆成功举办。中国工程院院士、著名岩土工程专家郑颖人,中国工程院院士、著名结构工程专家周绪红,重庆市科学技术局党委委员、副局长陈军,天津大学研究生院常务副院长、教授郑刚出席并作专题讲座,重庆市科学技术局、中建集团、中建五局相关负责人、专家、设计、施工建设相关管理人员和技术人员等共计150余人参会。",
        },
        {
          imgUrl: "../../../static/img/News/NewsOne/newsOne02.jpg",
          p: "在本次论坛大会上,中建五局河南公司万东波提出人机智联数字时代开启,施工现场应紧跟时代脉搏,积极拓展数据采集新路径。目前中建五局与河南南秀建筑科技有限公司基于此目的联合研发的数字化实测实量管理系统已研发成功,并由万东波向与会人员进行了详细汇报交流和视频展示。",
        },
        {
          imgUrl: "../../../static/img/News/NewsOne/newsOne03.jpg",
          p: "交流中提到数字化实测实量管理系统为解决当前施工现场中的管控难、效率低、产品贵、风险大四大痛点进行研发,该系统通过智能化硬件设备+智能应用软件+数据处理展示平台等形成体系化技术创新,通过自动化代替人工劳务、无纸化代替手抄纸存、加强数据可追溯性和数据实时性汇报,极大的提高施工效率和项目管控能力。",
        },
        {
          imgUrl: "",
          p: "会上多位领导及专家对数字化实测实量管理系统的细节进行了深度的询问和热烈的讨论,充分肯定了实测实量系统在实际场景应用中的作用,与会专家表示科技工作要充分把握国内国际的新形势和新导向,要把自身全产业链优势有效串联,通过科技创新提升中建五局的核心竞争力,科技工作方面要求加强对科技工作重要性的认识、强化科技创新意识、提升总结集成能力。希望对本次会议成果进一步学习探索,有理由相信随着科技发展驶入快车道,以虚拟质量样板为代表的新一代信息技术与建筑领域加速融合,将推动建筑数字化建设迈上新台阶。",
        },
      ],
    };
  },
  mounted() {
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  },
  methods: {
    getUnderStandMore() {
      this.$router.push({
        name: "AR",
      });
    },
  },
};
</script>

<style scoped>
.res_div img {
  width: 96%;
  margin: 10px 0;
}

.res_div_p {
  font-size: 30px;
  font-weight: bold;
  color: #000;
}

.font_div {
  font-size: 16px;
  line-height: 26px;
  margin-bottom: 10px;
}

.res_div_div {
  border-bottom: 1px dashed #e1e1e1;
  margin: 10px 0;
}

.news_ul_div_div02_sp {
  font-size: 12px;
  color: #888;
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/News/NewsOne.vue